<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('lineItems.handling')"
    class="shipment-handling-unit-filter"
    optional
  >
    <HandlingUnitFilter
      :id="inputId"
      v-model="modelValue.handlingUnit"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentSearchCriteria } from '@/model';

import HandlingUnitFilter from '@/components/search/HandlingUnitFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const modelValue = defineModel({
  type: ShipmentSearchCriteria,
  default: () => new ShipmentSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
